// assets
import ShopOutlined from '@ant-design/icons/ShopOutlined';
import MedicineBoxOutlined from '@ant-design/icons/MedicineBoxOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';

// icons
const icons = { ShopOutlined, MedicineBoxOutlined, UserOutlined };

// ==============================|| MENU ITEMS - SERVICE PROVIDERS ||============================== //

const serviceProviders = {
  id: 'service_providers',
  title: 'Service Providers',
  type: 'collapse',
  // No URL - this menu item does not link to a page
  icon: icons.ShopOutlined,
  // No permission required - visible to all users
  children: [
    {
      id: 'dentists',
      title: 'Dentists',
      type: 'item',
      url: '/dentists',
      icon: icons.UserOutlined,
      breadcrumbs: false,
      permission: {
        module: 'dentists',
        level: 10 // View permission required
      }
    },
    {
      id: 'emergency-dentists',
      title: 'Emergency Dentists',
      type: 'item',
      url: '/emergency-dentists',
      icon: icons.MedicineBoxOutlined,
      permission: {
        module: 'emergency_dentists',
        level: 10 // View permission required
      }
    },
    {
      id: 'specialists',
      title: 'Specialists',
      type: 'item',
      url: '/specialists',
      icon: icons.MedicineBoxOutlined,
      permission: {
        module: 'specialists',
        level: 10 // View permission required
      }
    }
  ]
};

export default serviceProviders;

